export default __webpack_public_path__ + "static/process-desktop-7be54f7a1b09902ff6457b1ab53c274f.svg";